<template>
  <div class="h-screen flex w-full bg-img">
    <div
      class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/4 lg:w-3/4 xl:w-1/2 mx-auto text-center"
    >
      <div
        class="grid grid-rows-2 md:grid-rows-1 grid-flow-col gap-0 lockscreen mt-5 mb-5"
      >
        <div class="lock-image auto-cols-min"></div>
        <div class="login-form text-left auto-cols-max">
          <div class="form-group mb-3">
            <vs-input
              label=""
              type="text"
              class="w-full mb-3"
              placeholder="Username"
            />
            <vs-input
              label=""
              type="text"
              class="w-full mb-3"
              placeholder="Enter your email"
            />
            <vs-input
              label=""
              type="password"
              class="w-full mb-3"
              placeholder="Password"
            />
            <vs-input
              label=""
              type="password"
              class="w-full mb-3"
              placeholder="Confirm password"
            />
          </div>
          <div class="form-group mb-0">
            <vs-button> Register </vs-button>
          </div>
          <p class="my-2 text-muted">--- Or register with ---</p>
          <a class="btn btn-social btn-dropbox text-white mb-2">
            <i class="icon-social-dropbox align-middle"></i>
          </a>
          <a class="btn btn-social btn-facebook text-white mb-2">
            <i class="icon-social-facebook align-middle"></i>
          </a>
          <a class="btn btn-social btn-github text-white mb-2">
            <i class="icon-social-github align-middle"></i>
          </a>
          <a class="btn btn-social btn-google text-white mb-2">
            <i class="icon-social-google align-middle"></i>
          </a>
          <div class="mt-2">
            Already have an account?
            <a href="/pages/login">Sign In</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      checkBox1: true,
      image: require("@/assets/images/author9.jpg"),
    };
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/styles/components/socialicon.scss";
</style>
